import React, { Component } from 'react';
import '../InfluencerMap.css';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import CustomerGroupsList from '../CustomerGroups/CustomerGroupsList/CustomerGroupsList';
import DisableNextModal from '../../../shared/Common/disableNextModal';


class CustomerGroupsLevel extends Component {
    constructor(props) {
        super(props);
        this.defaultParams;
        this.state = {
            createdData: false,
            editedData: false,
            deleteModalState: false,
            deletedItemId: null,
            stepSecondValidation: false,
        };
    }

    componentWillMount() {
        let body = {
            projectId: this.props.projectId,
            type: 'influencerMap'
        }
        this.props.getInfluencerMapGroups(body);
    }

    componentWillReceiveProps(nextProps) {
        // if (this.props.addInfluencerMapGroupsData !== nextProps.addInfluencerMapGroupsData) {
        //     // let body = {
        //     //     projectId: this.props.projectId,
        //     //     type: 'influencerMap'
        //     // }
        //     // this.props.getInfluencerMapGroups(body);
        //     this.props.groupStateNext();
        //     debugger
        // }
        if (nextProps.getInfluencerMapGroupsData !== this.props.getInfluencerMapGroupsData) {
            if (!_.isEmpty(nextProps.getInfluencerMapGroupsData.Items)) {
                //this.defaultParams = _.extend(nextProps.getInfluencerMapGroupsData.Items[0].groups)
                this.defaultParams = nextProps.getInfluencerMapGroupsData.Items[0].groups;
                let levelValue;
                for (let item of nextProps.getInfluencerMapGroupsData.Items[0].groups) {
                    levelValue = item.level ? true : false;
                }
                levelValue ? this.setState({ stepSecondValidation: true }) : '';
            }
        }
    }

    changeCustomerGroupLevel = (level, id) => {
        let levelValue;

        for (let item of this.defaultParams) {
            item.groupId === id ? item.level = level : '';
            levelValue = item.level || (item.level !==  '' ) ? true : false;
        }
        levelValue ? this.setState({ stepSecondValidation: true }) : this.setState({ stepSecondValidation: false });
    }

    nextLevel = () => {
        let body = {
            type : 'influencerMap',
            id : this.props.getInfluencerMapGroupsData.Items[0].id,
            groups : this.defaultParams
        }
        this.props.editInfluencerMapGroups(body);
        this.props.groupStateNext();
    }

    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                    <div className='rect1' />
                    <div className='rect2' />
                    <div className='rect3' />
                    <div className='rect4' />
                    <div className='rect5' />
                </div>
            </div>
        );
    }

    render() {

        return (
            <div className='customer-groups-content'>
                <div className='step-bar'>
                    <div className='step step-six arrow-step'>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-six arrow-step active-step'>
                        <p>Step 2</p>
                    </div>
                    <div className='step step-six arrow-step'>
                        <p>Step 3</p>
                    </div>
                    <div className='step step-six arrow-step'>
                        <p>Step 4</p>
                    </div>
                    <div className='step step-six arrow-step'>
                        <p>Step 5</p>
                    </div>
                    <div className='step step-six arrow-step '>
                        <p>Result</p>
                    </div>
                </div>
                {!this.props.getInfluencerMapGroupsFetching &&
                    <div className='container-fluid'>
                        <div className="row">
                          <div className="col-lg-7">
                            <h5>Influencer Map</h5>
                          </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-7'>
                                <div className='card'>
                                    <div className='card-header'>
                                        <h5>Customer Group - Current level of influence</h5>
                                        <span>Enter the current level of influence of each customer group from Step 1</span>
                                    </div>
                                    <div className='card-body'>
                                        {!_.isEmpty(this.props.getInfluencerMapGroupsData.Items) &&
                                            <CustomerGroupsList
                                                getInfluencerMapGroupsData={this.props.getInfluencerMapGroupsData}
                                                deleteItem={this.deleteItem}
                                                deleteModalOpen={this.deleteModalOpen}
                                                groupStepState={this.props.groupStepState}
                                                changeCustomerGroupLevel={this.changeCustomerGroupLevel}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>

                            <div className='col-sm-12'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <div onClick={this.state.stepSecondValidation ? this.nextLevel : this.props.disableNextModal} className='btn btn-success'> Next </div>
                                        <div onClick={this.props.groupStateBack} className='btn empty-btn default'> Back </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                }
                {this.props.getInfluencerMapGroupsFetching &&
                    <div className='card'>
                        <div className="card-body">
                            {this.elementInfiniteLoad()}
                        </div>
                    </div>
                }
                { this.props.disableNextState &&
                    <DisableNextModal
                        disableNextState={this.props.disableNextState}
                        disableNextModal={this.props.disableNextModal}
                        disableModalText='Please select a level of influence for each Customer Group'
                        disableModalTitle='Customer Group Influence'
                    />

                }
            </div>
        )
    }
}

export default (CustomerGroupsLevel);



// WEBPACK FOOTER //
// ./src/components/InfluencerMap/CustomerGroupsLevel/CustomerGroupsLevel.jsx